"use strict";

/*
 * Notifications widget
 */

(function ($) {
  var Days = {
    0: 'Воскресенье',
    1: 'Понедельник',
    2: 'Вторник',
    3: 'Среда',
    4: 'Четверг',
    5: 'Пятница',
    6: 'Суббота'
  };
  var Months = {
    0: 'Января',
    1: 'Февраля',
    2: 'Марта',
    3: 'Апреля',
    4: 'Мая',
    5: 'Июня',
    6: 'Июля',
    7: 'Августа',
    8: 'Сентября',
    9: 'Октября',
    10: 'Ноября',
    11: 'Декабря'
  };
  var notificationsService = {
    last: function last() {
      return $.ajax('/Notifications/GetLast', {
        cache: false,
        dataType: 'json',
        method: 'GET',
        traditional: true
      });
    },
    markAllAsRead: function markAllAsRead() {
      return $.ajax('/Notifications/MarkAllAsRead', {
        dataType: 'json',
        method: 'POST',
        traditional: true
      });
    },
    markAsRead: function markAsRead(id) {
      return $.ajax('/Notifications/MarkAsRead', {
        data: {
          notificationId: id
        },
        dataType: 'json',
        method: 'POST',
        traditional: true
      });
    }
  };

  // ReSharper disable once InconsistentNaming
  var Widget = function Widget() {
    var me = this;
    this.options = {
      $el: null,
      $list: null,
      $label: null,
      $link_refresh: null,
      $link_readall: null
    };
    this.items = []; // список уведомлений
    this.unreadCount = 0;
    this.updating = false; // процесс загрузки с сервера
    this.updating_callback = null; // функция, которую надо запустить после загрузки
    this.shake_loop = null; // интервал, который каждые 15 сек подергивает лейбл

    this.init = function () {
      this.options.$el = $('#notifications-widget');
      if (this.options.$el.length > 0) {
        this.options.$el.addClass('emptydata');
      }
      this.options.$list = this.options.$el.find('#notifications-widget__list');
      if (this.options.$list.length > 0) {
        this.options.$list.append($('<span class="notifications-nodata">Нет записей для отображения</span>'));
      }
      this.options.$label = this.options.$el.find('#notifications-widget__label');
      this.options.$link_refresh = this.options.$el.find('#notifications-widget__refresh');
      this.options.$link_readall = this.options.$el.find('#notifications-widget__readall');
      this.options.$el.on("mouseover", function () {
        $.b2b.MainMenuWidgets.open("#notifications-widget");
      }).on("mouseleave", function () {
        $.b2b.MainMenuWidgets.closeWidget();
      });
      this.options.$link_refresh.on('click', function (e) {
        e.preventDefault();
        me.update();
      });
      this.options.$link_readall.on('click', function (e) {
        e.preventDefault();
        me.markAllAsRead();
      });
    };

    // получение списка уведомлений с сервера
    this.update = function (disableRefresh) {
      if ($(document).find("#notifications-widget").length > 0) {
        this.updating = true;
        notificationsService.last().done(function (data) {
          me.updating = false;
          if (data.Success) {
            me.items = data.Data.Notifications;
            me.unreadCount = data.Data.UnreadCount;
            if (disableRefresh !== true) {
              me.refresh();
            }
            if (me.updating_callback) {
              me.updating_callback.call(me);
            }
            return;
          }

          // ?
        }).fail(function (jqXHR, textStatus, errorThrown) {
          me.updating = false;
          $.b2b.errors.showAjaxError(jqXHR);
          // ?
        });
      }
    };
    function addZ(n) {
      return n < 10 ? '0' + n : '' + n;
    }
    this.formatDate = function (arg) {
      var date = arg.date;
      var day = date.getDate();
      var day2 = date.getDay();
      var month = date.getMonth();
      var year = date.getFullYear();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var time = addZ(hours) + ':' + addZ(minutes);
      arg.title = Days[day2] + ', ' + day + ' ' + Months[month] + ', ' + year + ' в ' + time;
      arg.text = day + ' ' + Months[month] + ' в ' + time;
    };
    this.refresh = function () {
      if (this.options.$el) {
        if (this.updating) {
          // еще идет загрузка с сервера
          this.updating_callback = function () {
            me.refresh();
          };
          return;
        }
        var $ul = null;
        if (this.items.length > 0) {
          this.options.$el.removeClass('emptydata');
          // показываем число непрочитанных
          var $lab = this.options.$label; // alias
          if (this.unreadCount > 0) {
            $lab.text(this.unreadCount);
            $lab.removeClass('hidden');
            var shake = function shake() {
              $lab.addClass('shake shake-small');
              setTimeout(function () {
                $lab.removeClass('shake shake-small');
              }, 1100);
            };
            shake(); // call immediately
            me.shake_loop = setInterval(shake, 15000);
          } else {
            $lab.addClass('hidden');
            $lab.empty();
            if (me.shake_handler != null) {
              // clear shake loop
              clearInterval(me.shake_loop);
            }
          }

          // собираем список
          $ul = $('<ul/>');
          for (var i = 0; i < this.items.length; i++) {
            var $li = $('<li/>');
            var item = this.items[i];
            var date = new Date(item.DateCreated); // IE?                       
            var dateParams = {
              date: date,
              title: null,
              text: null
            };
            this.formatDate(dateParams);
            $li.append($('<span>' + item.Message + '</span>' + '<div class="notifications-date clearfix"><span title="' + dateParams.title + '"><i class="fa fa-calendar"></i><span class="date">' + dateParams.text + '</span></div>'));
            if (item.Url) {
              $li.addClass('linked');
              $li.data('item', item);
              var clickCallback = function clickCallback($el) {
                window.location.href = $el.data('item').Url;
              };
              $li.on('click', function (e) {
                e.preventDefault();
                var $el = $(this);

                // цель Я.Метрики - "Клик по уведомлению"
                Ya && Ya.reachGoal('Click_Notification');
                if ($el.data('item').Unread === false) {
                  // если уже прочитано, то переходим по ссылке
                  clickCallback($el);
                  return;
                }
                notificationsService.markAsRead($el.data('item').Id).always(function () {
                  $el.data('item').Unread = false;
                  clickCallback($el);
                });
              });
            }
            if (this.items[i].Unread) {
              $li.addClass('unread');
            }
            $ul.append($li);
          }
          this.options.$list.empty();
          if ($ul !== null) {
            this.options.$list.append($ul);
          }
        }
      }
    };
    this.markAllAsRead = function () {
      notificationsService.markAllAsRead().done(function (data) {
        if (data.Success) {
          me.unreadCount = 0;
          for (var i = 0; i < me.items.length; i++) {
            if (me.items[i].Unread) {
              me.items[i].Unread = false;
            }
          }
          me.refresh();
          return;
        }

        // fail ?
      }).fail(function (data) {
        // fail ?
      });
    };
  };

  // Запускаем сразу, но отрисуется тогда, когда DOM построен
  var instance = new Widget();
  instance.update(true);
  $(document).ready(function () {
    instance.init();
    instance.refresh();
  });
})(jQuery);